/**
 * Utilitário para gerenciar logs da aplicação de forma segura
 * Mascara dados sensíveis antes de exibir nos logs
 */

const maskSensitiveData = (data) => {
  if (!data) return data;
  
  // Se for um objeto ou array, processa recursivamente
  if (typeof data === 'object') {
    if (Array.isArray(data)) {
      return data.map(maskSensitiveData);
    }
    const masked = {};
    for (const [key, value] of Object.entries(data)) {
      masked[key] = maskSensitiveData(value);
    }
    return masked;
  }
  
  if (typeof data === 'string') {
    // Mascara emails
    if (data.includes('@')) {
      return data.replace(/(.{2}).*@/, '$1***@');
    }
    // Mascara UUIDs
    if (data.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
      return `${data.slice(0, 4)}...${data.slice(-4)}`;
    }
    // Mascara outros IDs longos
    if (data.length > 8) {
      return `${data.slice(0, 2)}...${data.slice(-2)}`;
    }
  }
  
  return data;
};

const processArgs = (args) => {
  return args.map(arg => {
    // Se for Error, extrai apenas a mensagem
    if (arg instanceof Error) {
      return arg.message;
    }
    return maskSensitiveData(arg);
  });
};

const logger = {
  auth: (message, ...args) => {
    const icon = message.toLowerCase().includes('error') ? '❌' : '🔐';
    console.info(`${icon} [Auth] ${message}`, ...processArgs(args));
  },

  payment: (message, ...args) => {
    const icon = message.toLowerCase().includes('error') ? '❌' : '💳';
    console.info(`${icon} [Payment] ${message}`, ...processArgs(args));
  },

  error: (message, ...args) => {
    console.error(`❌ [Error] ${message}`, ...processArgs(args));
  },

  warn: (message, ...args) => {
    console.warn(`⚠️ [Warn] ${message}`, ...processArgs(args));
  },

  info: (message, ...args) => {
    console.info(`ℹ️ [Info] ${message}`, ...processArgs(args));
  },

  debug: (message, ...args) => {
    console.log(`🔍 [Debug] ${message}`, ...processArgs(args));
  }
};

export default logger;
